// @flow

import React, { type ElementProps } from "react";
import { localize } from "redux-i18n";
import { type StepProps, Button } from "@components";
import type { ReportAreasField } from "@modules/reporting/reducer/types";
import ReportAreas from "../report-areas";

type OwnProps = $Exact<{
  hierarchyTree: Object,
  reportData: ?Object,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...StepProps,
  ...OwnProps,
  handleShowWarning: () => void,
}>;

type ComponentState = $Exact<{
  selected: Array<number>,
  excluded: Array<number>,
}>;

export class StepAreas extends React.Component<Props, ComponentState> {
  state = {
    selected: ((this.props.reportData || {}).filters || {}).selectedOrganisationalUnitIds || [],
    excluded: ((this.props.reportData || {}).filters || {}).excludedOrganisationalUnitIds || [],
  };

  removeItem = (from: ReportAreasField, id: number) => {
    this.setState({
      [from]: this.state[from].filter(item => item !== id),
    });
  };

  handleTreeUpdate = (selectedAreas: { selected: [number], excluded: [number] }) => {
    this.setState(selectedAreas);
    this.props.onChange(
      {
        selectedOrganisationalUnitIds: selectedAreas.selected,
        excludedOrganisationalUnitIds: selectedAreas.excluded,
      },
      true,
    );
  };

  onSubmitStep = () => {
    this.props.handleSubmit &&
      this.props.handleSubmit(
        {
          selectedOrganisationalUnitIds: this.state.selected,
          excludedOrganisationalUnitIds: this.state.excluded,
        },
        true,
      );
  };

  resetAreas = () => {
    this.setState({ selected: [], excluded: [] });
    this.props.handleShowWarning();
  };

  get isValid() {
    return this.state.selected.length >= 1;
  }

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      this.props.hierarchyTree && (
        <div className="w-100">
          <ReportAreas
            editable={!!this.props.editable}
            organizationStructure={this.props.hierarchyTree}
            selected={this.state.selected}
            excluded={this.state.excluded}
            onTreeUpdate={this.handleTreeUpdate}
            removeItem={this.removeItem}
            resetAreas={this.resetAreas}
          />
          {this.props.editable && (
            <div className="d-flex justify-content-end align-items-center w-100 mt-2 mb-2 mr-4">
              <Button
                materialIcon="fast_forward"
                disabled={!this.isValid}
                onClick={this.onSubmitStep}
              >
                {this.props.t("NEXT")}
              </Button>
            </div>
          )}
        </div>
      )
    );
  }
}

export default localize()(StepAreas);
